interface IconProps {
  className?: string;
}

const FontSizeIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-4 h-4"}
      {...rest}
    >
      <g fill="currentColor" clipPath="url(#clip0_1954_31735)">
        <path d="M1 6.604h2.066V4.713h2.18v8.575H3.51v2.065h5.54v-2.065H7.312V4.713h2.18v1.89h2.066V2.648H1zM15.933 5.307H17l-1.536-2.66-1.536 2.66h1.067v7.386h-1.067l1.536 2.66L17 12.693h-1.067z"></path>
      </g>
      <defs>
        <clipPath id="clip0_1954_31735">
          <path fill="#fff" d="M1 1h16v16H1z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default FontSizeIcon;
